export default __webpack_public_path__ + "static/media/NotoSans-Bold.82b1a58d.ttf";